import { getRandomId } from "../../../../../utils/random-id"

export const wizardContentInitialState = (parentId?: any, isNewStepCreation?: boolean) => {
    const stepConfig = [
        'Id', 'HeaderCol', 'HeaderText', 'ContentContainer', 'ContentText', 'FooterCol', 'FooterButton1', 'FooterButton2'
    ];
    function generateStepIds() {
        const stepIds: any = {};
        stepConfig.forEach(item => {
            stepIds[item] = getRandomId();
        });
        return stepIds;
    }
    const id = isNewStepCreation ? parentId : getRandomId();
    const steps: any = {};
    const stepCount: number = isNewStepCreation ? 1 : 4;
    for (let i = 1; i <= stepCount; i++) {
        steps[`Step ${i}`] = generateStepIds();
    }
    let components: any = {}
    if(!isNewStepCreation) {
        components[id] = {
            "id": id,
            "fields": [
                steps['Step 1'].Id,
                steps['Step 2'].Id,
                steps['Step 3'].Id,
                steps['Step 4'].Id
            ],
            "properties": {
                "styles": {
                    "common": {
                        "badge": {}
                    },
                    "Sm": {
                        "gridCols": "1",
                        "gridRows": "0",
                        "span": "1",
                        "rowSpan": "1",
                        "visible": true,
                        "widthMode": "%",
                        "heightMode": "%",
                        "height": "100",
                        "width": "100",
                        "wizardWidth": "100",
                        "wizardWidthMode": "%",
                        "wizardStyle": {
                            "color1": "#1B1B1A",
                            "color2": "#EDC951",
                            "color3": "#FFFFFF",
                            "color4": "#F2F2F2",
                            "color5": "#494948"
                        }
                    },
                    "Md": {
                        "gridCols": "1",
                        "gridRows": "0",
                        "span": "1",
                        "rowSpan": "1",
                        "visible": true,
                        "widthMode": "%",
                        "heightMode": "%",
                        "height": "100",
                        "width": "100",
                        "wizardWidth": "30",
                        "wizardWidthMode": "%",
                        "wizardStyle": {
                            "color1": "#1B1B1A",
                            "color2": "#EDC951",
                            "color3": "#FFFFFF",
                            "color4": "#F2F2F2",
                            "color5": "#494948"
                        }
                    },
                    "Lg": {
                        "gridCols": "1",
                        "gridRows": "0",
                        "span": "1",
                        "rowSpan": "1",
                        "visible": true,
                        "widthMode": "%",
                        "heightMode": "%",
                        "height": "100",
                        "width": "100",
                        "wizardWidth": "20",
                        "wizardWidthMode": "%",
                        "wizardStyle": {
                            "color1": "#1B1B1A",
                            "color2": "#EDC951",
                            "color3": "#FFFFFF",
                            "color4": "#F2F2F2",
                            "color5": "#494948"
                        }
                    },
                },
                "config": {
                    "visible": true,
                    "title": "Title",
                    "showWizardHeader": true,
                    "showWizardStepsStatus": true,
                    "showStepsDescription": true,
                    "cellConditions": [],
                    "section": []
                }
            },
            "type": "FormWizard",
            "label": "Form Wizard",
            "parentId": parentId ? parentId : ''
        }
    }
    Object.keys(steps).map((step, i) => {
        const stepComponents = steps[step];
        Object.keys(stepComponents).map((component,j) => {
            if(component === 'Id') {
                components[stepComponents[component]] = {
                    "id": stepComponents[component],
                    "fields": [
                        stepComponents['HeaderCol'],
                        stepComponents['ContentContainer'],
                        stepComponents['FooterCol']
                    ],
                    "properties": {
                        "styles": {
                            "common": {},
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "width": "100",
                                "widthMode": "%",
                                "disable": false,
                                "visible": true,
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "disable": false,
                                "visible": true,
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "disable": false,
                                "visible": true,
                            }
                        },
                        "config": {
                            "visible": true
                        }
                    },
                    "title": `${step}`,
                    "description": "Loerm Ipsum is simply",
                    "type": "FormWizardStep",
                    "label": `Form Wizard ${step}`,
                    "parentId": id
                }
            } else if (component === 'HeaderCol') {
                components[stepComponents[component]] = {
                    "id": stepComponents[component],
                    "fields": [
                        stepComponents['HeaderText']
                    ],
                    "properties": {
                        "styles": {
                            "common": {
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "background": "#D20202",
                                    "textColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "borderWidth": 1,
                                    "borderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "width": "100",
                                "widthMode": "%",
                                "heightMode": "px",
                                "height": "60",
                                "backgroundColor": "#F6F6F7",
                                "flexDistribute": "center",
                                "flexAlign": "center"
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "heightMode": "px",
                                "height": "100",
                                "widthMode": "%",
                                "width": "100",
                                "backgroundColor": "#F6F6F7",
                                "flexDistribute": "center",
                                "flexAlign": "center"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "%",
                                "heightMode": "px",
                                "height": "100",
                                "width": "100",
                                "backgroundColor": "#F6F6F7",
                                "flexDistribute": "center",
                                "flexAlign": "center"
                            }
                        },
                        "config": {
                            "visible": true,
                            "enableBadge": false,
                            "classNameTags": [],
                            "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }"
                        }
                    },
                    "type": "Column",
                    "label": "Column",
                    "parentId": stepComponents['Id']
                }
            } else if (component === 'ContentContainer') {
                components[stepComponents[component]] = {
                    "id": stepComponents[component],
                    "fields": [
                        stepComponents['ContentText']
                    ],
                    "properties": {
                        "styles": {
                            "common": {
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "background": "#D20202",
                                    "textColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "borderWidth": 1,
                                    "borderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "width": "100",
                                "widthMode": "%",
                                "heightMode": "%",
                                "height": "100",
                                "flexGrow": "1",
                                "flexShrink": "1",
                                "flexDistribute": "center",
                                "flexAlign": "center"
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "%",
                                "width": "100",
                                "heightMode": "%",
                                "height": "100",
                                "flexGrow": "1",
                                "flexShrink": "1",
                                "flexDistribute": "center",
                                "flexAlign": "center"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "%",
                                "width": "100",
                                "heightMode": "%",
                                "height": "100",
                                "flexGrow": "1",
                                "flexShrink": "1",
                                "flexDistribute": "center",
                                "flexAlign": "center"
                            }
                        },
                        "config": {
                            "visible": true,
                            "enableBadge": false,
                            "classNameTags": [],
                            "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }"
                        }
                    },
                    "type": "Container",
                    "label": "Container",
                    "parentId": stepComponents['Id']
                }
            } else if (component === 'FooterCol') {
                components[stepComponents[component]] = {
                    "id": stepComponents[component],
                    "fields": [
                        stepComponents['FooterButton1'],
                        stepComponents['FooterButton2']
                    ],
                    "properties": {
                        "styles": {
                            "common": {
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "background": "#D20202",
                                    "textColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "borderWidth": 1,
                                    "borderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "width": "100",
                                "widthMode": "%",
                                "heightMode": "px",
                                "height": "60",
                                "backgroundColor": "#F6F6F7",
                                "flexAlign": "center",
                                "flexDistribute": "center",
                                "fixed": true,
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "heightMode": "px",
                                "height": "100",
                                "widthMode": "%",
                                "width": "100",
                                "backgroundColor": "#F6F6F7",
                                "flexAlign": "center",
                                "flexDistribute": "end"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "%",
                                "width": "100",
                                "heightMode": "px",
                                "height": "100",
                                "backgroundColor": "#F6F6F7",
                                "flexAlign": "center",
                                "flexDistribute": "end"
                            }
                        },
                        "config": {
                            "visible": true,
                            "enableBadge": false,
                            "classNameTags": [],
                            "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }",
                            "renderOn": ""
                        }
                    },
                    "type": "Row",
                    "label": "Row",
                    "parentId": stepComponents['Id']
                }
            } else if (component === 'HeaderText') {
                components[stepComponents[component]] = {
                    "id": stepComponents[component],
                    "fields": [],
                    "properties": {
                        "styles": {
                            "common": {
                                "textAlign": "",
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "badgeBackground": "#D20202",
                                    "badgeTextColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "badgeBorderWidth": 1,
                                    "badgeBorderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "auto",
                                "heightMode": "px",
                                "backgroundColor": "#F6F6F7",
                                "width": "auto"
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "auto",
                                "heightMode": "px",
                                "backgroundColor": "#F6F6F7",
                                "width": "auto"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "auto",
                                "heightMode": "px",
                                "backgroundColor": "#F6F6F7",
                                "width": "auto"
                            }
                        },
                        "config": {
                            "visible": true,
                            "bind": "",
                            "classNameTags": [],
                            "persistBlock": false,
                            "copy": false,
                            "icon": "",
                            "iconGap": 5,
                            "widthHeight": "",
                            "copyText": "",
                            "background": "#000000",
                            "borderRadius": 16,
                            "borderWidth": 0,
                            "borderColor": "#0000FF",
                            "fontSize": "",
                            "fontWeight": "",
                            "fontColor": "#FFFFFF",
                            "padding": {
                                "overall": 6,
                                "top": "0",
                                "right": "0",
                                "bottom": "0",
                                "left": "0"
                            },
                            "enableBadge": false,
                            "onClick": "async function main(asset, flatlistData) {\n  // Start of editable area\n  \n  // End of editable area\n}"
                        },
                        "text": `Step ${i+1}`
                    },
                    "type": "Text",
                    "label": "Label",
                    "parentId": stepComponents['HeaderCol']
                }
            } else if (component === 'ContentText') {
                components[stepComponents[component]] = {
                    "id": stepComponents[component],
                    "fields": [],
                    "properties": {
                        "styles": {
                            "common": {
                                "textAlign": "",
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "badgeBackground": "#D20202",
                                    "badgeTextColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "badgeBorderWidth": 1,
                                    "badgeBorderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "auto",
                                "heightMode": "px",
                                "width": "auto"
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "auto",
                                "heightMode": "px",
                                "width": "auto"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "auto",
                                "heightMode": "px",
                                "width": "auto"
                            }
                        },
                        "config": {
                            "visible": true,
                            "bind": "",
                            "classNameTags": [],
                            "persistBlock": false,
                            "copy": false,
                            "icon": "",
                            "iconGap": 5,
                            "widthHeight": "",
                            "copyText": "",
                            "background": "#000000",
                            "borderRadius": 16,
                            "borderWidth": 0,
                            "borderColor": "#0000FF",
                            "fontSize": "",
                            "fontWeight": "",
                            "fontColor": "#FFFFFF",
                            "padding": {
                                "overall": 6,
                                "top": "0",
                                "right": "0",
                                "bottom": "0",
                                "left": "0"
                            },
                            "enableBadge": false,
                            "onClick": "async function main(asset, flatlistData) {\n  // Start of editable area\n  \n  // End of editable area\n}"
                        },
                        "text": `Content ${i+1}`
                    },
                    "type": "Text",
                    "label": "Label",
                    "parentId": stepComponents['ContentContainer']
                }
            } else if (component === 'FooterButton1') {
                components[stepComponents[component]]= {
                    "id": stepComponents[component],
                    "fields": [],
                    "properties": {
                        "styles": {
                            "common": {
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "background": "#D20202",
                                    "textColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "borderWidth": 1,
                                    "borderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                },
                                "loader": {
                                    "loaderColor": "#ffffff",
                                    "placement": "0"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "px",
                                "heightMode": "px",
                                "marginRight": "30",
                                "backgroundColor": "#ffffffff",
                                "color": "#1B1B1A",
                                "borderColor": "#1B1B1A",
                                "width": "150"
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "px",
                                "heightMode": "px",
                                "marginRight": "30",
                                "backgroundColor": "#ffffffff",
                                "color": "#1B1B1A",
                                "borderColor": "#1B1B1A",
                                "width": "150"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "px",
                                "heightMode": "px",
                                "marginRight": "30",
                                "backgroundColor": "#ffffffff",
                                "color": "#1B1B1A",
                                "borderColor": "#1B1B1A",
                                "width": "150"
                            }
                        },
                        "config": {
                            "visible": (i !== 0 ? true : false),
                            "bind": "",
                            "classNameTags": [],
                            "disabled": false,
                            "loader": false,
                            "enableOnHistoryView": false,
                            "enableBadge": false,
                            "visualFeedback": false,
                            "hoverColor": "",
                            "onClick": `async function main(asset, flatlistData) {\n      // Start of editable area\n   a8forms.FormWizard('${id}').previousStep();   \n      // End of editable area\n    }`
                        }
                    },
                    "type": "Button",
                    "label": "Previous",
                    "parentId": stepComponents['FooterCol']
                }
            } else if (component === 'FooterButton2') {
                components[stepComponents[component]] = {
                   "id": stepComponents[component],
                    "fields": [],
                    "properties": {
                        "styles": {
                            "common": {
                                "badge": {
                                    "badgeBindBadge": "",
                                    "defaultValue": 10,
                                    "background": "#D20202",
                                    "textColor": "#fff",
                                    "badgeFontSize": 14,
                                    "badgeBorderRadius": 20,
                                    "borderWidth": 1,
                                    "borderColor": "#FFFFFF",
                                    "position": "custom",
                                    "customVertical": "top",
                                    "customHorizontal": "right"
                                },
                                "loader": {
                                    "loaderColor": "#ffffff",
                                    "placement": "0"
                                }
                            },
                            "Sm": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "px",
                                "heightMode": "px",
                                "backgroundColor": "#1B1B1A",
                                "width": "150"
                            },
                            "Md": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "px",
                                "heightMode": "px",
                                "backgroundColor": "#1B1B1A",
                                "width": "150"
                            },
                            "Lg": {
                                "gridCols": "1",
                                "gridRows": "0",
                                "span": "1",
                                "rowSpan": "1",
                                "visible": true,
                                "widthMode": "px",
                                "heightMode": "px",
                                "backgroundColor": "#1B1B1A",
                                "width": "150"
                            }
                        },
                        "config": {
                            "visible": (i !== 3 ? true : false),
                            "bind": "",
                            "classNameTags": [],
                            "disabled": false,
                            "loader": false,
                            "enableOnHistoryView": false,
                            "enableBadge": false,
                            "visualFeedback": false,
                            "hoverColor": "",
                            "onClick": `async function main(asset, flatlistData) {\n      // Start of editable area\n   a8forms.FormWizard('${id}').nextStep();   \n      // End of editable area\n    }`
                        }
                    },
                    "type": "Button",
                    "label": "Next",
                    "parentId": stepComponents['FooterCol']
                }
            }
        })
    })
    const returnValue = {
        components: components,
        id: id
    }
    return returnValue
}